const config = {
  NAME: 'Registro',
    PATH: '/register',
};

export default config;
